import { useOfferStore, selectScrapedAt } from '@store/offerStore'
import { useTheme } from '@hooks/useTheme'
import { getWeekLabel, getNextWeekLabel, getFreshness, FRESHNESS_META, formatRelativeTime } from '@utils/constants'
import styles from './Header.module.css'

function PremiumToggle() {
  const hasAHPremium = useOfferStore(s => s.hasAHPremium)
  const catalogLoading = useOfferStore(s => s.catalogLoading)
  const toggleAHPremium = useOfferStore(s => s.toggleAHPremium)

  const chipClass = hasAHPremium
    ? `${styles.premiumChip} ${styles.premiumActive}`
    : styles.premiumChip

  const label = hasAHPremium
    ? 'AH Premium actief — klik om uit te schakelen'
    : 'AH Premium inschakelen — 10% korting op bio'

  return (
    <button
      className={chipClass}
      onClick={toggleAHPremium}
      title={label}
      aria-label={label}
      aria-pressed={hasAHPremium}
      type="button"
    >
      <span className={styles.premiumIcon}>{catalogLoading ? '⏳' : '💎'}</span>
      <span className={styles.premiumLabel}>Premium</span>
    </button>
  )
}

function HeaderBrand() {
  return (
    <div className={styles.componentBrand}>
      <span className={styles.logo} role="img" aria-label="Biologisch">🥦</span>
      <h1 className={styles.title}>Bio Aanbiedingen</h1>
    </div>
  )
}

function HeaderMeta({ weekLabel, freshnessInfo, themeLabel, themeIcon, onToggleTheme }) {
  return (
    <div className={styles.componentMeta}>
      <span className={styles.week}>{weekLabel}</span>
      {freshnessInfo}
      <PremiumToggle />
      <button
        className={styles.themeToggle}
        onClick={onToggleTheme}
        title={themeLabel}
        aria-label={themeLabel}
        type="button"
      >
        <span className={styles.themeToggleIcon}>
          {themeIcon}
        </span>
      </button>
    </div>
  )
}

export function Header() {
  const scrapedAt = useOfferStore(selectScrapedAt)
  const selectedWeek = useOfferStore(s => s.selectedWeek)
  const { theme, toggle: toggleTheme } = useTheme()

  const isUpcoming = selectedWeek === 'upcoming'
  const weekLabel = isUpcoming ? getNextWeekLabel() : getWeekLabel()
  const freshness = getFreshness(scrapedAt)
  const freshnessMeta = FRESHNESS_META[freshness]

  const isDark = theme === 'dark'
  const themeLabel = isDark
    ? 'Schakel naar licht thema'
    : 'Schakel naar donker thema'
  const themeIcon = isDark ? '☀️' : '🌙'

  const freshnessInfo = scrapedAt && (
    <span
      className={styles.freshness}
      title={`Laatst bijgewerkt: ${new Date(scrapedAt).toLocaleString('nl-NL')}`}
    >
      <span>{freshnessMeta.icon}</span>
      <span style={{ color: freshnessMeta.color }}>
        {formatRelativeTime(scrapedAt)}
      </span>
    </span>
  )

  return (
    <header className={styles.component_root}>
      <div className={styles.inner}>
        <HeaderBrand />
        <HeaderMeta
          {...{ weekLabel, freshnessInfo, themeLabel, themeIcon }}
          onToggleTheme={toggleTheme}
        />
      </div>
    </header>
  )
}
